export class IMWebSocket extends WebSocket {
  isNeedReconnect = true;
  constructor(url, protocols) {
    super(url, protocols);
  }
}
